export default function Marquee({ marquee }) {
  const words = (marquee && marquee.words) || [];
  const loop = [...words, ...words, ...words, ...words];
  return (
    <section data-testid="marquee-section" className="overflow-hidden border-y border-white/5 bg-navy-dark py-6 md:py-8">
      <div className="flex w-max animate-marquee items-center">
        {loop.map((w, i) => (
          <span key={i} className="flex items-center">
            <span
              className={`font-display text-3xl font-black uppercase tracking-tight md:text-5xl lg:text-6xl ${
                w.style === "outline" ? "text-outline" : "text-white"
              }`}
            >
              {w.text}
            </span>
            <span className="mx-6 h-2 w-2 rounded-full bg-[#FF5722] md:mx-10 md:h-2.5 md:w-2.5" />
          </span>
        ))}
      </div>
    </section>
  );
}
